import diff from '../common/lib/deepDiff';
import { fabric } from 'fabric';
import isEmpty from 'lodash-es/isEmpty';
import pickBy from 'lodash-es/pickBy';

export const scaleDownObjectToFitSize = (object, size) => {
  if (object.width > size.width || object.height > size.height) {
    const scale = fabric.util.findScaleToFit(object, size);
    if (scale < object.scaleX) {
      object.scale(scale);
    }
  }
};

export const scaleDownObjectToFillSize = (object, size) => {
  if (object.width > size.width || object.height > size.height) {
    const scale = fabric.util.findScaleToCover(object, size);
    if (scale < object.scaleX) {
      object.scale(scale);
    }
  }
};

const EXCLUSION_LIST = [
  'strokeMiterLimit',
  'version',
  // 'editable',
  // 'evented',
  // 'selectable',
  'perPixelTargetFind',
  'strokeMiterLimit',
  'clipTo',
  'paintFirst',
  'fillRule',
  '_objects',
  'path',
];

export const getObjectsDiff = (
  originalObject,
  newObject,
  exclusionList = EXCLUSION_LIST,
) => {
  const _originalObject = pickBy(
    originalObject,
    (value, key) => !exclusionList.includes(key),
  );
  const _newObject = pickBy(
    newObject,
    (value, key) => !exclusionList.includes(key),
  );

  const changes = diff(_originalObject, _newObject);
  /**
   * The `merge` function ignores the undefined values.
   * They must be converted to null instead of undefined.
   *  */
  Object.keys(changes).forEach(key => {
    if (changes[key] === undefined) {
      changes[key] = null;
    }
  });

  return changes;
};

export const getModifiedObjects = (originalContent, newContent) => {
  const removed = Object.values(originalContent.objects || {})
    .filter(object => !newContent.objects[object.canvasId])
    .map(object => object.canvasId);

  const added = Object.values(newContent.objects).filter(
    object => !originalContent.objects?.[object.canvasId],
  );

  const modified = Object.values(newContent.objects)
    .filter(
      object =>
        !removed.includes(object.canvasId) &&
        !added
          .map(addedObject => addedObject.canvasId)
          .includes(object.canvasId),
    )
    .map(object => {
      const originalObject = originalContent.objects[object.canvasId];

      const diffs = getObjectsDiff(originalObject, object);

      // TO CHECK
      // SHOULDN'T WE RETURN ALL OBJECTS TO KEEP TEMPLATE UP TO DATE ALL THE TIME?
      if (!isEmpty(diffs)) {
        return { originalObject, diffs };
      }
    })
    .filter(Boolean);

  return {
    added,
    modified,
    removed,
  };
};
